module.exports = __webpack_public_path__ + "static/media/personal.ba688f9e.jpg";